import { render, staticRenderFns } from "./CustomModal.vue?vue&type=template&id=bf9355c6"
import script from "./CustomModal.vue?vue&type=script&lang=ts"
export * from "./CustomModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports